<template>
  <div class="main-page">
    <layout-header :isHome="true"></layout-header>
    <section class="box_a">
      <article>
        <div class="wrap">

          <div class="maintitle">
            <h1>
              기업의 원스톱 서비스
            </h1>
          </div>
          <div class="subtitle">
            <p>
              전력비 절감 고객의 업무관리<br>
              데이터 산출 - 현장 조사 - 사후관리 까지<br>
              이 모든 서비스를 한 곳에서
            </p>
          </div>
          <div class="download">
            <ul>
              <li>
                <a href="https://play.google.com/store/apps/details?id=com.appg.kiupnuri" target="_blank">
                  <img src="@/assets/img/android.png" alt="안드로이드">
                  <span>AOS 다운로드</span>
                </a>
              </li>
              <li>
                <a href="https://apps.apple.com/kr/app/%EA%B8%B0%EC%97%85%EB%88%84%EB%A6%AC/id6444148655" target="_blank">
                  <img src="@/assets/img/apple.png" alt="애플">
                  <span>iOS 다운로드</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

      </article>
    </section>
    <!--end::section-->

    <section class="box_b" id="introduce">
      <article>
        <div>
          <div class="box_b_txt">
            <p>
              <span>원가절감</span>의 숙제는 어렵고 <br>
              방법이나 신청 및 <strong>사후관리</strong>는 어떻게?
            </p>
            <h1>
              <strong><span>기업누리가</span> 바꿔나갑니다.</strong>
            </h1>
          </div>
        </div>
      </article>
    </section>
    <!--end::section-->

    <section class="box_c">
      <article>
        <div class="box_1">
          <div class="image">
            <img src="@/assets/img/intro1.png" alt="핸드폰">
          </div>
          <div class="txt">
            <p class="num">
              01.
            </p>
            <p class="main">
              고객번호 하나로<br>
              전력비 절감 무료 분석
            </p>
            <!--              <p class="sub">-->
            <!--                기업누리! 매출감소시장에 대응하는 원가절감이-->
            <!--                보완해줬다!-->
            <!--              </p>-->
          </div>
        </div>
      </article>
    </section>
    <section class="box_d">
      <article>
        <div class="box_1">
          <div class="txt_2">
            <p class="num">
              02.
            </p>
            <p class="main">
              한번 승인으로<br>
              반영구적 절감액 확인 가능
            </p>
            <!--              <p class="sub">-->
            <!--                기업누리! 매출감소시장에 대응하는 원가절감<br>-->
            <!--                이 보완해줬다!기업-->
            <!--              </p>-->
          </div>
          <div class="image_2">
            <img src="@/assets/img/intro2.png" alt="핸드폰">
          </div>
        </div>
      </article>
    </section>
    <section class="box_e">
      <article>
        <div class="box_1">
          <div class="image">
            <img src="@/assets/img/intro3.png" alt="핸드폰">
          </div>
          <div class="txt">
            <p class="num">
              03.
            </p>
            <p class="main">
              전문가 현장 방문으로<br>
              정확한 데이터 산출
            </p>
            <!--              <p class="sub">-->
            <!--                기업누리! 매출감소시장에 대응하는 원가절감이-->
            <!--                보완해줬다!-->
            <!--              </p>-->
          </div>
        </div>
      </article>
    </section>
    <!--end::section-->

    <section class="box_f">
      <div class="bg_box">
        <article>
          <div>
            <div class="minibox">
              <img src="@/assets/img/minibox.png" alt="체크">
            </div>
            <h1>
              기업에 필요한 추가 서비스
            </h1>
            <div class="phone">
              <div style="">
                <img src="@/assets/img/more4.png" alt="핸드폰">
              </div>
              <div>
                <img src="@/assets/img/more2.png" alt="핸드폰">
              </div>
              <div>
                <img src="@/assets/img/more3.png" alt="핸드폰">
              </div>
            </div>
            <div class="cardbox">
              <div class="card">
                <div class="card_icon">
                  <img src="@/assets/img/icon-1.png" alt="아이콘">
                </div>
                <div class="card_main_txt">
                  다양한 서비스
                </div>
                <!--                  <p class="card_sub_txt">-->
                <!--                    기업누리! 매출감소시장에 대응하는 원가 절감<br>-->
                <!--                    이 보완해줬다!매출감소시장에 대응하는 원가절감이 보완해줬다!-->
                <!--                  </p>-->
              </div>
              <div class="card">
                <div class="card_icon">
                  <img src="@/assets/img/icon-2.png" alt="아이콘">
                </div>
                <div class="card_main_txt">
                  기업인증 서비스
                </div>
                <!--                  <p class="card_sub_txt">-->
                <!--                    기업누리! 매출감소시장에 대응하는 원가 절감<br>-->
                <!--                    이 보완해줬다!매출감소시장에 대응하는 원가절감이 보완해줬다!-->
                <!--                  </p>-->
              </div>
              <div class="card">
                <div class="card_icon">
                  <img src="@/assets/img/icon-3.png" alt="아이콘">
                </div>
                <div class="card_main_txt">
                  연구소 서비스
                </div>
                <!--                  <p class="card_sub_txt">-->
                <!--                    기업누리! 매출감소시장에 대응하는 원가 절감<br>-->
                <!--                    이 보완해줬다!매출감소시장에 대응하는 원가절감이 보완해줬다!-->
                <!--                  </p>-->
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>
    <!--end::section-->

    <section class="box_g" id="partner">
      <article>
        <div>
          <div class="minibox_2">
            <img src="@/assets/img/minibox-2.png" alt="상승아이콘">
          </div>
          <h1>
            대기업부터 스타트업까지
          </h1>
          <p>
            수많은 기업들이 기업누리와 함께했습니다.
          </p>
        </div>
        <div class="logo_box">
          <ul>
            <li v-for="(partner, index) in partnerList" :key="index">
              <img :src="$Util.loadImage(480, partner.partnerLogoImage)" alt="">
            </li>
            <!--              <li>-->
            <!--                <img src="@/assets/img/cj.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/youhan.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/kakao.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/naver.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/poseco.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/dusan.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/samsung.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/lg.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/shinsegae.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/sk.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/lotte.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/hanhwa.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/cjpost.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/pulmuone.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/kakao.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/naver.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/poseco.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/samsung.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/lg.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/shinsegae.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/sk.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/sk.png" alt="">-->
            <!--              </li>-->
            <!--              <li>-->
            <!--                <img src="@/assets/img/sk.png" alt="">-->
            <!--              </li>-->
          </ul>
        </div>
      </article>
    </section>
    <!--end::section-->
    <section class="box_h" id="customer">
      <article>
        <div>
          <div>
            <h1>
              홍보 영상
            </h1>
          </div>
          <div class="thumnail">
            <div v-for="(customerCase, index) in customerCaseList" :key="index">
              <iframe style="width: 100%; height: 100%;" :src="`https://www.youtube.com/embed/${customerCase.youtubeURL}`" frameborder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              <p>{{ customerCase.caseTitle }}</p>
            </div>
          </div>
        </div>
      </article>
    </section>
    <section class="box_i" id="inquire">
      <article>
        <div class="intro">
          <h1>
            도입문의 요청
          </h1>
          <p>
            솔루션을 통해, 전력비 절감을 이룰 수 있습니다.<br>
            기업누리가 바꿔드립니다
          </p>
          <div class="signup_form">
            <form>
              <div>
                <select v-model="params.serviceType">
                  <option v-for="(item, index) in $ConstCode.CODE_SERVICE_TYPE" :key="index" :value="item.value">{{ item.label }}</option>
                </select>
                <span>문의 서비스 *</span>
              </div>
              <div :class="{fals: $v.params.companyName.$error}">
                <input type="text" :class="{'is-invalid': $v.params.companyName.$error}" v-model="params.companyName">
                <span>회사명 *</span>
                <p class="pw_fals" v-show="$v.params.companyName.$error">필수 입력 항목입니다.</p>
              </div>
              <div :class="{fals: $v.params.name.$error}">
                <input type="text" :class="{'is-invalid': $v.params.name.$error}" v-model="params.name">
                <span>이름 *</span>
                <p class="pw_fals" v-show="$v.params.name.$error">필수 입력 항목입니다.</p>
              </div>
              <div :class="{fals: $v.params.tel.$error}">
                <input type="text" :class="{'is-invalid': $v.params.tel.$error}" v-model="params.tel">
                <span>전화번호 *</span>
                <p class="pw_fals" v-show="$v.params.tel.$error">필수 입력 항목입니다.</p>
              </div>
              <div :class="{fals: $v.params.email.$error}">
                <input type="text" :class="{'is-invalid': $v.params.email.$error}" v-model="params.email">
                <span>E-Mail *</span>
                <p class="pw_fals" v-show="$v.params.email.$error">필수 입력 항목입니다.</p>
              </div>
              <div>
                <input type="text" name="name" v-model="params.hearPlace">
                <span>접한 곳</span>
              </div>
              <div>
                <textarea v-model="params.description"></textarea>
                <span>내용</span>
              </div>
            </form>
            <form class="bottom_form">
              <div class="flex_box">
                <div class="input_box">
                  <input type="checkbox" id="privacy" v-model="params.privacy" @change="$v.params.privacy.$touch()">
                </div>
                <div class="form_txt_1">
                  <label for="privacy">개인정보 활용 동의</label>
                  <p v-show="params.privacy === false">필수 동의 항목입니다.</p>
                </div>
                <div class="form_txt_2" @click="showTermsPrivacy" style="cursor: pointer;">약관보기</div>
              </div>
              <div class="btn">
                <button type="button" @click="registInquire">
                  문의 등록
                </button>
              </div>
            </form>
          </div>
        </div>
      </article>
    </section>
    <!--end::section-->

    <layout-footer></layout-footer>

    <terms-privacy-modal v-bind:isShow="termsPrivacy.isShow"
                         v-bind:callBack="() => {}"
                         v-on:eventClose="() => {termsPrivacy.isShow = false}">
    </terms-privacy-modal>

  </div>
</template>

<script>
import required from "vuelidate/lib/validators/required";

export default {
  data: function () {
    return {
      termsPrivacy: {
        isShow: false,
      },
      bannerList: [],
      noticeList: [],
      customerCaseList: [],
      partnerList: [],
      params: {
        serviceType: 1,
        companyName: '',
        name: '',
        tel: '',
        email: '',
        hearPlace: '',
        description: '',
        privacy: true
      }
    }
  },
  validations: {
    params: {
      companyName: {
        required
      },
      name: {
        required
      },
      tel: {
        required
      },
      email: {
        required
      },
    }
  },
  computed: {
    userData: function () {
      return this.$store.getters['account/getUserData']
    }
  },
  created: async function () {
    await this.$AccountSvc.refreshUserData()
    await this.getMainData()
  },
  mounted: function () {
  },
  methods: {
    showTermsPrivacy: function () {
      this.termsPrivacy.isShow = true
    },
    getMainData: async function () {
      const params = {
        userNo: this.userData.userNo
      }

      const res = await this.$MainSvc.getMainData(params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      if (code === 1) {
        this.bannerList = entity.bannerList
        this.noticeList = entity.noticeList
        this.customerCaseList = entity.customerCaseList
        this.partnerList = entity.partnerList
      }
    },
    registInquire: async function () {
      if (!this.params.privacy) {
        alert('false')
      }
      this.$v.$touch()
      if (!this.$Util.isValid(this.$v, this.$el)) {
        return false
      }

      if (!confirm('문의 등록하시겠습니까?')) {
        return false
      }

      const res = await this.$AccountSvc.registInquire(this.params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        alert('등록되었습니다.')
        this.$v.$reset()
        this.params = {
          serviceType: 1,
          companyName: '',
          name: '',
          tel: '',
          email: '',
          hearPlace: '',
          description: '',
          privacy: true
        }
      } else {
        alert(message)
      }
    }
  }
}
</script>
